import React, { useState, useEffect, useMemo } from 'react';
import './VerseOfTheDay.css';

interface Verse {
  reference: string;
  text: string;
  translation: string;
}

interface StoredVerseData {
  verse: Verse;
  timestamp: number;
  dayOfYear: number;
}

// A comprehensive collection of Bible verse references covering the entire year
// First group: Well-known and frequently cited verses
const verseReferences = [
  // January
  "john+3:16", "romans+8:28", "jeremiah+29:11", "philippians+4:13", "genesis+1:1", 
  "psalm+23:1-6", "1corinthians+13:4-8", "proverbs+3:5-6", "isaiah+40:31", "matthew+28:19-20",
  "romans+12:2", "philippians+4:6-7", "john+14:6", "matthew+11:28-30", "romans+5:8",
  "galatians+5:22-23", "hebrews+11:1", "2timothy+3:16-17", "1john+4:7-8", "matthew+5:16",
  "isaiah+41:10", "psalm+46:1", "john+1:1", "romans+3:23", "psalm+91:1-16",
  "matthew+6:33", "james+1:2-4", "romans+6:23", "hebrews+13:8", "1peter+5:7",
  "psalm+139:13-14",
  
  // February
  "colossians+3:23", "deuteronomy+31:6", "2corinthians+5:17", "ephesians+2:8-9", "james+1:5",
  "psalm+119:105", "1chronicles+16:11", "proverbs+16:9", "john+13:34-35", "romans+10:9",
  "matthew+5:3-12", "john+15:13", "psalm+37:4-5", "proverbs+18:21", "isaiah+26:3",
  "joshua+1:9", "psalm+1:1-3", "ephesians+3:20", "john+8:32", "matthew+22:37-39",
  "psalm+32:8", "1peter+3:15", "proverbs+4:23", "colossians+3:12-14", "psalm+34:8",
  "philippians+1:6", "james+4:7", "proverbs+3:7-8", "hebrews+4:16",
  
  // March
  "james+1:22", "psalm+37:23-24", "luke+6:31", "1john+1:9", "proverbs+22:6",
  "psalm+103:2-5", "2timothy+1:7", "psalm+127:1", "genesis+50:20", "ephesians+6:11-18",
  "proverbs+27:17", "lamentations+3:22-23", "john+10:10", "psalm+37:4", "philippians+3:13-14",
  "ephesians+4:32", "psalm+119:9-11", "ecclesiastes+3:1-8", "psalm+19:14", "2corinthians+4:18",
  "proverbs+16:3", "matthew+5:14-16", "philippians+2:3-4", "psalm+46:10", "john+16:33",
  "proverbs+3:9-10", "romans+15:13", "revelation+3:20", "proverbs+30:5", "psalm+150:6",
  "job+23:10",
  
  // April 
  "matthew+11:28", "exodus+14:14", "revelation+21:4", "1thessalonians+5:16-18", "deuteronomy+6:5-7",
  "psalm+56:3", "romans+12:1", "isaiah+43:2", "hebrews+12:1-2", "2corinthians+12:9",
  "psalm+145:18", "proverbs+31:25", "isaiah+55:8-9", "matthew+18:20", "2corinthians+5:7",
  "psalm+73:26", "james+5:16", "isaiah+53:5", "psalm+62:1-2", "proverbs+17:17",
  "deuteronomy+7:9", "hebrews+10:24-25", "romans+8:38-39", "psalm+27:1", "isaiah+41:13",
  "jeremiah+33:3", "micah+7:7", "isaiah+1:18", "psalm+51:10", "zephaniah+3:17",
  
  // May
  "psalm+121:1-2", "exodus+33:14", "psalm+23:4", "romans+8:26", "matthew+11:29",
  "philippians+4:8", "hebrews+4:12", "psalm+138:8", "matthew+7:7-8", "ephesians+1:7",
  "psalm+16:11", "john+15:5", "ecclesiastes+4:9-10", "colossians+2:6-7", "psalm+86:5",
  "habakkuk+3:17-19", "1corinthians+10:13", "psalm+34:4", "proverbs+10:12", "luke+1:37",
  "psalm+33:4-5", "matthew+19:26", "proverbs+15:1", "psalm+107:1", "isaiah+61:1-3",
  "ephesians+5:25-27", "john+14:27", "proverbs+19:21", "psalm+40:1-3", "judges+6:12",
  "galatians+6:9",
  
  // June
  "acts+1:8", "psalm+55:22", "james+1:17", "psalm+18:2", "ephesians+6:1-3",
  "matthew+6:25-27", "colossians+1:16-17", "psalm+118:24", "isaiah+40:28-29", "hebrews+11:6",
  "deuteronomy+10:17-18", "john+11:35", "galatians+2:20", "psalm+19:1", "proverbs+16:24",
  "isaiah+40:8", "psalm+34:17-18", "hebrews+12:14", "micah+6:8", "psalm+42:1-2",
  "1peter+2:9", "psalm+68:5-6", "john+8:12", "psalm+1:6", "jeremiah+17:7-8",
  "1corinthians+16:14", "psalm+29:11", "galatians+5:1", "psalm+147:3", "proverbs+3:3-4",
  
  // July
  "colossians+3:15", "james+3:17-18", "psalm+37:7", "1john+3:1", "proverbs+12:25",
  "hebrews+13:5", "psalm+63:3-4", "galatians+6:2", "romans+1:16", "psalm+20:4",
  "1peter+5:8-9", "psalm+119:114", "john+4:24", "psalm+34:14", "romans+8:1-2",
  "proverbs+17:22", "psalm+119:165", "matthew+5:44-45", "psalm+84:10", "isaiah+12:2",
  "hosea+6:3", "psalm+119:9", "philippians+2:13", "psalm+94:18-19", "john+15:12",
  "isaiah+30:21", "psalm+37:30-31", "romans+8:31", "psalm+25:4-5", "2peter+1:3",
  "job+42:2",
  
  // August
  "colossians+4:2", "psalm+30:5", "isaiah+25:1", "psalm+119:50", "acts+4:12",
  "psalm+86:15", "daniel+2:23", "psalm+71:8", "ephesians+2:10", "psalm+141:3",
  "1peter+4:8", "psalm+73:23-24", "matthew+5:6", "psalm+7:17", "john+1:14",
  "ecclesiastes+3:11", "psalm+112:7", "revelation+21:5", "psalm+5:3", "malachi+3:6",
  "nahum+1:7", "psalm+96:1-3", "hebrews+6:19", "psalm+9:9-10", "1corinthians+15:58",
  "psalm+115:1", "matthew+6:19-21", "psalm+40:11", "luke+6:45", "psalm+90:12",
  "job+5:8-9",
  
  // September
  "1chronicles+29:11", "psalm+145:9", "ephesians+1:18-19", "psalm+119:60", "john+17:3",
  "psalm+32:7", "hebrews+13:15", "psalm+16:8", "romans+12:12", "psalm+66:1-2",
  "job+37:5", "psalm+81:1", "1john+2:17", "psalm+139:1-4", "matthew+11:30",
  "psalm+139:23-24", "james+4:8", "psalm+119:105", "acts+17:28", "psalm+125:1",
  "deuteronomy+4:29", "psalm+119:2", "isaiah+12:5", "psalm+103:13", "2corinthians+3:17",
  "psalm+63:1", "matthew+10:29-31", "psalm+61:1-3", "acts+16:31", "psalm+119:30",
  
  // October
  "malachi+3:10", "psalm+145:3", "ephesians+3:16-17", "psalm+29:4", "romans+8:18",
  "psalm+9:1-2", "isaiah+43:19", "psalm+71:14", "proverbs+13:20", "psalm+118:6-7",
  "jude+1:24-25", "psalm+145:18-19", "1john+3:16", "psalm+46:1-3", "mark+10:27",
  "psalm+31:24", "isaiah+65:24", "psalm+133:1", "1peter+1:3", "psalm+91:11",
  "isaiah+58:11", "psalm+119:37", "john+6:35", "psalm+100:4-5", "1corinthians+2:9",
  "psalm+121:7-8", "matthew+24:35", "psalm+52:8-9", "romans+5:3-5", "psalm+119:160",
  "exodus+15:2",
  
  // November
  "acts+2:21", "psalm+30:11-12", "james+4:10", "psalm+45:1", "titus+2:11-12",
  "psalm+57:1", "romans+14:8", "psalm+111:10", "1corinthians+15:57", "psalm+97:10",
  "isaiah+26:12", "psalm+119:18", "matthew+25:23", "psalm+18:30", "colossians+1:13-14",
  "psalm+19:7", "hebrews+12:11", "psalm+119:89-90", "john+14:2-3", "psalm+86:7",
  "revelation+1:8", "psalm+126:3", "luke+12:32", "psalm+40:5", "romans+15:5-6",
  "psalm+16:1-2", "mark+12:30-31", "psalm+94:22", "hebrews+13:16", "psalm+119:133",
  
  // December
  "john+1:12", "psalm+89:1", "isaiah+9:6", "psalm+98:4", "matthew+1:23",
  "psalm+96:11-12", "luke+2:10-11", "psalm+34:3", "colossians+1:15-16", "psalm+37:3",
  "revelation+22:20", "psalm+65:8", "matthew+2:10-11", "psalm+113:3", "1timothy+1:15-17",
  "psalm+36:5-6", "luke+1:46-47", "psalm+20:7", "2corinthians+9:15", "psalm+95:1-2",
  "romans+11:36", "psalm+89:8", "titus+3:4-5", "psalm+77:11-12", "revelation+19:6",
  "psalm+66:5", "john+3:17", "psalm+136:1", "luke+11:13", "psalm+117:1-2",
  "isaiah+9:2"
];

// Fallback verses if API fails
const fallbackVerses: Verse[] = [
  {
    reference: "Proverbs 3:5-6",
    text: "Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight.",
    translation: "NIV"
  },
  {
    reference: "Philippians 4:13",
    text: "I can do all things through Christ who strengthens me.",
    translation: "NKJV"
  },
  {
    reference: "Isaiah 40:31",
    text: "But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.",
    translation: "NIV"
  },
  {
    reference: "Psalm 23:1",
    text: "The LORD is my shepherd, I lack nothing.",
    translation: "NIV"
  },
  {
    reference: "Matthew 11:28",
    text: "Come to me, all you who are weary and burdened, and I will give you rest.",
    translation: "NIV"
  },
  {
    reference: "Romans 8:28",
    text: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.",
    translation: "NIV"
  },
  {
    reference: "John 3:16",
    text: "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.",
    translation: "NIV"
  }
];

interface VerseOfTheDayProps {
  className?: string;
}

const VerseOfTheDay: React.FC<VerseOfTheDayProps> = ({ className = '' }) => {
  const [verse, setVerse] = useState<Verse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [textSize, setTextSize] = useState('1rem'); // Default text size
  
  // Constants
  const STORAGE_KEY = 'verseOfTheDay';
  const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  // Function to fetch verse from API
  const fetchVerseFromAPI = async (reference: string): Promise<Verse | null> => {
    try {
      const response = await fetch(`https://bible-api.com/${reference}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch verse');
      }
      
      const data = await response.json();
      
      return {
        reference: data.reference,
        text: data.text.trim(),
        translation: data.translation_name || 'World English Bible'
      };
    } catch (error) {
      console.error('Error fetching verse from API:', error);
      return null;
    }
  };

  // Function to get a fallback verse
  const getFallbackVerse = (): Verse => {
    const randomIndex = Math.floor(Math.random() * fallbackVerses.length);
    return fallbackVerses[randomIndex];
  };

  // Get today's verse reference based on the day of the year
  const getDayOfYear = (): number => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = (now.getTime() - start.getTime()) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
    return Math.floor(diff / ONE_DAY_MS);
  };

  // Get verse reference based on day of year
  const getTodayVerseReference = (dayOfYear: number): string => {
    // Ensure we have a valid index within our array bounds
    return verseReferences[dayOfYear % verseReferences.length];
  };

  // Adjust text size based on verse length
  useEffect(() => {
    if (verse) {
      const textLength = verse.text.length;
      
      // Adjust text size based on text length with appropriately larger font sizes
      if (textLength < 60) {
        setTextSize('1.6rem'); // Larger text for very short verses
      } else if (textLength < 120) {
        setTextSize('1.5rem'); // Medium-large text for short verses
      } else if (textLength < 250) {
        setTextSize('1.4rem'); // Medium text for medium verses
      } else if (textLength < 400) {
        setTextSize('1.2rem'); // Normal text for longer verses
      } else {
        setTextSize('1.1rem'); // Smaller but still readable for very long verses
      }
    }
  }, [verse]);

  // Custom styles for responsive text size - only keeping fontSize changes
  const textStyle = useMemo(() => ({
    fontSize: textSize,
    lineHeight: '1.5',
    fontStyle: 'italic'
  }), [textSize]);

  useEffect(() => {
    const getVerse = async () => {
      setIsLoading(true);
      
      // Get current day of year
      const currentDayOfYear = getDayOfYear();
      
      // Check if we have a stored verse
      const storedData = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();
      
      if (storedData) {
        try {
          const parsedData: StoredVerseData = JSON.parse(storedData);
          const { verse: storedVerse, timestamp, dayOfYear: storedDayOfYear } = parsedData;
          
          // Check if the stored verse is less than 24 hours old AND from the same day of year
          // This handles both time-based expiration and date changes
          if (now - timestamp < ONE_DAY_MS && storedDayOfYear === currentDayOfYear) {
            // Use the stored verse if it's still valid
            setVerse(storedVerse);
            setIsLoading(false);
            return;
          }
        } catch (error) {
          console.error('Error parsing stored verse:', error);
          // Continue to get a new verse if parsing fails
        }
      }
      
      // If we don't have a valid stored verse, get a new one
      const reference = getTodayVerseReference(currentDayOfYear);
      
      // Try to fetch from API first
      const apiVerse = await fetchVerseFromAPI(reference);
      
      // Use API verse or fallback if API fails
      const newVerse = apiVerse || getFallbackVerse();
      
      // Store the new verse with current timestamp and day of year
      const verseData: StoredVerseData = {
        verse: newVerse,
        timestamp: now,
        dayOfYear: currentDayOfYear
      };
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(verseData));
      setVerse(newVerse);
      setIsLoading(false);
    };

    getVerse();
  }, []);

  return (
    <div className={`verse-of-the-day card-hover ${className}`}>
      <h3 className="verse-title">Verse of the Day</h3>
      {isLoading ? (
        <div className="verse-loading">
          <div className="verse-loading-text">Seeking wisdom...</div>
          <div className="verse-loading-bar"></div>
        </div>
      ) : (
        verse && (
          <div className="verse-content">
            <p className="verse-text" style={textStyle}>{verse.text}</p>
            <div className="verse-reference">
              <p>{verse.reference} <span className="verse-translation">({verse.translation})</span></p>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default VerseOfTheDay;